import { ReactElement } from 'react';
import styles from '@/styles/components/shade-loding.module.less';
import { useTranslation } from '@/services';
import TokenName from '../token/TokenName';
import contractConstants from '@/services/contract.constants';
const BurnLoad = (props: SwapLoadData): ReactElement => {
    const { t } = useTranslation('common', 'shade');
    return (
        <div className={styles['mint']}>
            {t('burn.y-w-m')}&nbsp; {t('burn.amount')} <span>{props.token}</span>
            <span>
                <TokenName token={contractConstants.Registries.AGDToken} />
            </span>
            <br />
            {t('burn.sell')} &nbsp;<span>{props.cToken} </span>
            <span>
                <TokenName token={contractConstants.Registries.PoolPaymentToken} />
            </span>
        </div>
    );
};

export default BurnLoad;
